import React, { Fragment } from 'react';

import { awsServer, imagePath, ahPath } from '../../utilities/UrlPaths';
import { ReactComponent as LogoSVG } from '../Payments/inv_logo.svg';

const Banner = ({ ppEnabled, payrixEligible, ppType, ppEligible }) => {
  const isValidPaymentType = ppEnabled && (ppType === 'w' || ppType === 's');
  const invaluablePaymentsUrl = isValidPaymentType ? `${imagePath}/payments/switch` : `${imagePath}/payments/signup`;
  const stripeUrl = `${ahPath()}/ah/payments/enroll`;

  return (
    <Fragment>
      {/* Conditional banner for Payrix eligibility */}
      {(ppType !== 'p' && payrixEligible) && (
        <a href={invaluablePaymentsUrl} target="_blank" className="paymentFeature" rel="noopener noreferrer">
          <div className="auctionRequiredBannerWrapper">
            <img src={`${awsServer}/static/paymentsPhoto.jpg`} alt="payments" className="auctionRequiredBanner" />
            <img src={`${awsServer}/static/actionRequiredTag.png`} className="auctionRequiredTag" alt="Action Required Tag" />
          </div>
          <div className="paymentContentWrapper">
            <div className="paymentContent">
              <LogoSVG className="logo-400" />
              <p>
                With Invaluable Payments you can charge cards on file 2 days after invoicing,
                enable bank transfers for easier buyer checkout, update
                paid invoices with additional charges, and&nbsp;more!
              </p>
            </div>
            <div className="paymentButton">
              <a href={invaluablePaymentsUrl} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                Get Started
              </a>
            </div>
          </div>
        </a>
      )}
      {/* Conditional banner for Stripe enroll */}
      {ppType === 's' && ppEligible && !ppEnabled && !payrixEligible && (
        <a href={stripeUrl} target="_blank" className="paymentFeature" rel="noopener noreferrer">
          <div className="auctionRequiredBannerWrapper">
            <img src={`${awsServer}/static/paymentsPhoto.jpg`} alt="payments" className="auctionRequiredBanner" />
            <img src={`${awsServer}/static/actionRequiredTag.png`} className="auctionRequiredTag" alt="Action Required Tag" />
          </div>
          <div className="paymentContentWrapper">
            <div className="paymentContent">
              <h3 className="stripe-copy mt-3">
                Sign up for Payment Processing powered by Stripe
              </h3>
              <p>
                Collect payments online with Stripe payment processing.
                This fast & secure option allows you to get paid quicky by buyers patricipating in your auctions online on Invaluable, AuctionZip and Private Label.
              </p>
            </div>
            <div className="paymentButton">
              <a href={stripeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                Get Started
              </a>
            </div>
          </div>
        </a>
      )}
    </Fragment>
  );
};

export default Banner;
